import { useContext } from 'react';
import { ChatRealtimeContext } from './context';

export const useChatRealtime = () => useContext(ChatRealtimeContext);
